import { render, staticRenderFns } from "./CustomDetailTabs.vue?vue&type=template&id=7cd2b626&"
import script from "./CustomDetailTabs.vue?vue&type=script&lang=js&"
export * from "./CustomDetailTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports